"use strict";
import n from "./index.es99.js";
import f from "./index.es103.js";
import l from "./index.es113.js";
function d(i, o) {
  const t = this || f, a = o || t, e = l.from(a.headers);
  let r = a.data;
  return n.forEach(i, function(m) {
    r = m.call(t, r, e.normalize(), o ? o.status : void 0);
  }), e.normalize(), r;
}
export {
  d as default
};
//# sourceMappingURL=index.es169.js.map
